import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Star, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { isLegacyStoreContent } from "@/lib/xplosivContent";

const empty = { name: "", location: "", rating: 5, title: "", body: "", avatar: "", is_published: true, product_slug: "" };

export default function AdminReviews() {
    const [items, setItems] = useState([]);
    const [form, setForm] = useState(empty);

    const load = async () => setItems((await api.get("/admin/reviews")).data.filter((item) => !isLegacyStoreContent(item)));
    useEffect(() => { load(); }, []);

    const save = async (e) => {
        e.preventDefault();
        try {
            await api.post("/admin/reviews", { ...form, rating: Number(form.rating) });
            toast.success("Review added"); setForm(empty); load();
        } catch (e) { toast.error("Save failed"); }
    };
    const del = async (id) => {
        if (!window.confirm("Delete review?")) return;
        await api.delete(`/admin/reviews/${id}`); load();
    };

    return (
        <div data-testid="admin-reviews-page">
            <h1 className="font-display text-4xl">Event testimonials</h1>
            <p className="text-muted-foreground mt-1">Manage client stories and testimonials shown on the X-Plosiv website.</p>
            <form onSubmit={save} className="mt-6">
                <Card className="rounded-[20px] border-[#E7DED2] bg-white/80">
                    <CardContent className="p-6 grid sm:grid-cols-2 gap-3">
                        <Fld label="Name"><Input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></Fld>
                        <Fld label="Location"><Input value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} /></Fld>
                        <Fld label="Rating (1-5)"><Input type="number" min="1" max="5" value={form.rating} onChange={e => setForm({ ...form, rating: e.target.value })} /></Fld>
                        <Fld label="Avatar URL"><Input value={form.avatar} onChange={e => setForm({ ...form, avatar: e.target.value })} /></Fld>
                        <Fld label="Headline"><Input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} /></Fld>
                        <Fld label="Product slug (optional)"><Input value={form.product_slug} onChange={e => setForm({ ...form, product_slug: e.target.value })} /></Fld>
                        <div className="sm:col-span-2"><Fld label="Body"><Textarea rows={3} required value={form.body} onChange={e => setForm({ ...form, body: e.target.value })} /></Fld></div>
                        <div className="flex items-center justify-between sm:col-span-2"><Label>Published</Label><Switch checked={form.is_published} onCheckedChange={v => setForm({ ...form, is_published: v })} /></div>
                        <div className="sm:col-span-2"><button type="submit" className="dw-btn-primary px-5 py-2 font-mono-ui" data-testid="admin-review-save">Add review</button></div>
                    </CardContent>
                </Card>
            </form>

            <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {items.map(r => (
                    <Card key={r.id} className="rounded-[20px] border-[#E7DED2] bg-white/80">
                        <CardContent className="p-5">
                            <div className="flex items-center gap-3">
                                <img src={r.avatar} alt="" className="h-10 w-10 rounded-full" />
                                <div className="flex-1">
                                    <p className="text-sm font-medium">{r.name}</p>
                                    <p className="text-xs text-muted-foreground">{r.location}</p>
                                </div>
                                <div className="flex gap-0.5">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} className="h-3 w-3 fill-[#1B1B1F] text-[#1B1B1F]" />)}</div>
                            </div>
                            <p className="font-display text-lg mt-3">{r.title}</p>
                            <p className="text-xs text-[#3a342e] mt-2 line-clamp-3">{r.body}</p>
                            <button onClick={() => del(r.id)} className="mt-3 text-xs font-mono-ui text-[#B42318]"><Trash2 className="h-3 w-3 inline" /> Delete</button>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
}

function Fld({ label, children }) { return <div><Label className="font-mono-ui mb-1.5 block">{label}</Label>{children}</div>; }
